module.exports = __webpack_public_path__ + "img/glm_gbt923_1988.prt.99dea8d5.jpg";